import React from "react";
import "./we_repair_section.css";

function WeRepairSection() {
    const repairItems = [
        {
            brand: "COVE",
            category: "DISHWASHERS",
            img: "/images/cove-dishwasher.png",
            imgClass: "cove-dishwasher-img"
        },
        {
            brand: "SUB-ZERO",
            category: "REFRIGERATORS",
            img: "/images/subzero-ref.png",
            imgClass: "subzero-fridge-img"
        },
        {
            brand: "SUB-ZERO",
            category: "WINE-COOLERS",
            img: "/images/wine-cooler.png",
            imgClass: "subzero-wine-img"
        },
        {
            brand: "WOLF",
            category: "COOKTOPS & MICROWAVES",
            images: [
                { src: "/images/wolf-cooktop.png", alt: "Wolf Cooktop", imgClass: "wolf-cooktop-img" },
                { src: "/images/wolf-microwave.png", alt: "Wolf Microwave", imgClass: "wolf-micro-img" }
            ]
        },
        {
            brand: "WOLF",
            category: "BUILT-IN OVENS",
            img: "/images/subzero_Appliance11.jpg",
            imgClass: "wolf-oven-img"
        },
        {
            brand: "WOLF",
            category: "VENTILATIONS",
            img: "/images/wolf-hood.png",
            imgClass: "wolf-vent-img"
        }
    ];

    return (
        <section className="we-repair-section" id="we-repair">
            <h2 className="we-repair-title">WE REPAIR</h2>

            <div className="repair-grid">
                {repairItems.map((item, idx) => (
                    <div className="repair-item" key={idx}>
                        <p className="repair-item-brand">{item.brand}</p>
                        <hr className="side-separator-brand" />
                        <p className="repair-item-text">{item.category}</p>

                        {item.images ? (
                            item.images.map((imgObj, imgIdx) => (
                                <img
                                    key={imgIdx}
                                    src={imgObj.src}
                                    alt={imgObj.alt}
                                    className={`repair-item-image ${imgObj.imgClass || ""}`}
                                />
                            ))
                        ) : (
                            <img
                                src={item.img}
                                alt={`${item.brand} ${item.category}`}
                                className={`repair-item-image ${item.imgClass || ""}`}
                            />
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}

export default WeRepairSection;